var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 177,
    viewBox: "0 0 183 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.666 91.2959C179.812 87.336 178.925 83.406 177.092 79.8922C177.033 78.3754 176.819 76.8685 176.455 75.3947C175.469 71.5147 173.501 67.9535 170.74 65.0539C167.979 62.1543 164.518 60.0139 160.69 58.8388C159.041 58.3273 157.339 58.0029 155.618 57.8715L155.168 57.6253C153.975 57.0152 152.733 56.505 151.455 56.1C151.201 53.5704 150.467 51.1121 149.293 48.8565L141.616 34.0675C140.99 32.8617 140.244 31.7221 139.389 30.6659C140.28 25.7482 139.309 20.6749 136.664 16.4332C134.019 12.1915 129.891 9.08494 125.082 7.71825L105.845 2.22376C102.924 1.3892 99.8521 1.22473 96.8589 1.74272C93.8657 2.26071 91.0283 3.44775 88.5583 5.21525C86.0884 6.98276 84.0497 9.28514 82.5943 11.9505C81.1389 14.6159 80.3042 17.5756 80.1529 20.6086L80.0843 21.955C79.1376 22.2437 78.2145 22.6043 77.3229 23.0338L61.7861 30.5203C60.558 31.1123 59.3933 31.8275 58.3098 32.6549C55.2194 31.0469 51.8032 30.1634 48.3206 30.0716L47.8079 30.069C42.6685 27.656 36.8193 27.2246 31.3819 28.8574C25.9446 30.4902 21.3019 34.0723 18.3443 38.9167C15.0414 41.1057 12.3612 44.1118 10.5642 47.6426C2.73692 54.0632 -0.257451 65.5663 2.52632 79.6029C3.47673 84.3959 7.05706 97.6642 10.4813 106.033C11.9062 109.494 14.7094 118.254 16.8805 125.338L15.7263 129.801C14.387 134.979 15.1605 140.478 17.8768 145.088C20.593 149.697 25.0295 153.039 30.2101 154.379L110.742 175.114C115.922 176.452 121.422 175.679 126.032 172.965C130.642 170.25 133.984 165.817 135.325 160.639L136.476 156.188C141.803 151.07 148.532 144.748 151.432 142.406C158.474 136.783 168.041 126.876 171.202 123.146C180.479 112.228 183.4 100.706 179.666 91.2959Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.575 98.4874C117.575 98.4874 128.73 94.2265 136.467 85.3661C144.204 76.5056 146.702 73.4294 149.636 74.9483C155.06 77.7475 147.391 86.4437 144.669 89.8582C141.153 94.2563 132.996 101.501 132.996 101.501",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.389 89.2068C145.389 89.2068 153.073 80.6769 155.238 78.7619C158.146 76.162 160.94 78.2227 161.357 79.9285C161.837 81.8651 159.876 85.1257 157.322 88.5187C154.768 91.9117 144.668 103.955 140.576 107.366",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.302 88.5199C157.302 88.5199 160.93 85.8267 163.269 88.6663C165.153 90.953 163.96 93.0285 160.806 97.6629C157.651 102.297 149.207 112.813 144.66 115.268",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.481 97.8977C128.481 97.8977 140.405 106.594 145.7 118.259",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.174 98.4739C160.174 98.4739 163.047 96.0079 165.319 99.1093C167.298 101.81 162.815 108.79 160.201 111.889C157.587 114.987 148.42 124.478 142.087 129.544C135.753 134.61 120.208 149.87 120.208 149.87L117.466 160.47L79.3555 150.614C79.3555 150.614 83.3396 133.651 86.5896 121.084C89.8396 108.516 99.5501 100.14 106.284 95.1843C113.018 90.2283 116.174 86.2636 118.804 83.4813C121.88 80.2299 126.738 84.1365 124.836 88.2502C122.934 92.364 112.704 104.38 112.704 104.38C115.669 109.683 116.606 115.881 115.342 121.822",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.27 110.969C124.27 110.969 129.263 117.568 129.81 123.017",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3875 84.0542C61.3875 84.0542 53.6969 74.9197 51.2209 63.4117C48.745 51.9036 48.0544 48.0158 44.7532 47.9156C38.6588 47.7362 41.1483 59.0659 41.8738 63.372C42.8181 68.9169 46.4407 79.2079 46.4407 79.2079",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5588 62.4265C41.5588 62.4265 38.9796 51.2425 38.0081 48.5163C36.7253 44.8326 33.284 45.2744 32.0866 46.5627C30.7321 48.0313 30.8664 51.8337 31.4569 56.0334C32.0474 60.2331 35.0336 75.6733 36.9668 80.636",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.473 56.0701C31.473 56.0701 29.5985 51.9606 26.1835 53.3056C23.419 54.3966 23.4624 56.7918 23.9747 62.3744C24.4869 67.957 26.7746 81.2483 29.5627 85.5941",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1525 78.2495C52.1525 78.2495 37.5093 80.0687 27.2217 87.7109",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1532 63.395C24.1532 63.395 22.8358 59.8454 19.347 61.4506C16.3069 62.8535 16.8419 71.1378 17.628 75.1088C18.414 79.0797 21.8214 91.8356 24.9123 99.3323C28.0033 106.829 34.1945 127.717 34.1945 127.717L31.4531 138.317L69.9415 148.271L77.5594 118.813C80.8078 106.252 76.3769 94.2123 72.8916 86.6071C69.4064 79.002 68.5599 74.0085 67.6084 70.3001C66.5018 65.9604 60.3576 67.0283 60.0269 71.5485C59.6962 76.0686 62.818 91.5373 62.818 91.5373C57.6545 94.7348 53.83 99.6999 52.0571 105.508",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4786 91.7578C49.4786 91.7578 41.9063 95.1067 38.7881 99.6011",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.329 70.9596L125.921 40.558L134.122 56.3596L106.329 70.9596Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1211 53.453L121.472 23.2127L100.916 17.3383L99.1211 53.453Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3573 76.4232L85.7314 38.265L69.1406 46.2584L85.3573 76.4232Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive3);
export default __webpack_public_path__ + "static/media/archive3.2d93c6fc173e8e1d29f7d968187dcd1e.svg";
export { ForwardRef as ReactComponent };